import styles from '../../../../styles/Calendar.module.scss';

function WeekSelector({ week, setWeek, loading, setLoading, maxWeek = 3 }) {

	const decrement = async () => {
		setLoading(true);
		await setWeek(week - 1 < 0 ? 0 : week - 1)
	}

	const increment = async () => {
		setLoading(true);
		await setWeek(week + 1 > maxWeek ? maxWeek : week + 1)
	}

	return (
		<div className={styles.weekSelector}>
			<button className="btn btnEmpty" onClick={decrement} disabled={(week < 1) || loading}>Prev</button>
			<button className="btn btnEmpty" onClick={increment} disabled={(maxWeek - 1 < week) || loading}>Next</button>
		</div>
	)
}

export default WeekSelector;